export default __webpack_public_path__ + "static/media/DataMapIcon.3355c02f.svg";